var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vinput" }, [
    _c("label", { staticClass: "vinput-label", attrs: { "for-id": _vm.id } }, [
      _vm._v(_vm._s(_vm.label))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "vinput-wr" }, [
      _c(
        "textarea",
        _vm._b(
          {
            ref: "input",
            staticClass: "vinput-input",
            attrs: { id: _vm.id, type: _vm.type },
            on: {
              blur: _vm.handleBlur,
              focus: _vm.handleFocus,
              input: _vm.handleInput
            }
          },
          "textarea",
          _vm.$attrs,
          false
        )
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }